import { useMemo } from "react"
import NotChromeBrowswerBanner from "src/common/NotChromeBrowserBanner"
import { useBrowserType } from './useBrowserType';

export const useChromeBrowserBanner = () => {

    const { isChromeBrowser } = useBrowserType()

    const MemoizedModalComponent = useMemo(() => {
        return <NotChromeBrowswerBanner />
    }, [isChromeBrowser])

    return {
        NotAChromeBrowserBanner: !isChromeBrowser ? MemoizedModalComponent : <></>,
    }
}